export class Sticker {
    static fromStickerDTO(dto) {
        return new Sticker(dto.parkId, dto.name, dto.stickerUrl, dto.isUnlocked, dto.stickerKey, dto.stickerDate, dto.stickerProviderName, dto.stickerProviderLink, dto.states);
    }
    toJSON() {
        return {
            parkId: this.parkId,
            name: this.name,
            stickerUrl: this.stickerUrl,
            isUnlocked: this.isUnlocked,
            stickerKey: this.stickerKey,
            id: this.parkId,
            stickerDate: this.stickerDate,
            stickerProviderName: this.stickerProviderName,
            stickerProviderLink: this.stickerProviderLink,
            states: this.states
        };
    }
    get id() {
        return this.parkId;
    }
    constructor(parkId, name, stickerUrl, isUnlocked, stickerKey, stickerDate, stickerProviderName, stickerProviderLink, states){
        this.parkId = parkId;
        this.name = name;
        this.stickerUrl = stickerUrl;
        this.isUnlocked = isUnlocked;
        this.stickerKey = stickerKey;
        this.stickerDate = stickerDate;
        this.stickerProviderName = stickerProviderName;
        this.stickerProviderLink = stickerProviderLink;
        this.states = states;
    }
}
